<template>
  <el-container>
    <el-container v-if="showeditmain">
      <el-aside v-if="showaside" style="min-height: 600px;overflow: auto;">
        <el-tree
          :data="gtypedatas"
          ref="gt_tree_list"
          show-checkbox
          highlight-current
          current-node-key="id"
          node-key="id"
          @node-drag-start="handleDragStart"
          @node-drag-enter="handleDragEnter"
          @node-drag-leave="handleDragLeave"
          @node-drag-over="handleDragOver"
          @node-drag-end="handleDragEnd"
          @node-drop="handleDrop"
          draggable
          :allow-drop="allowDrop"
          :allow-drag="allowDrag"
          :check-strictly = "true"
          :expand-on-click-node="false"
          default-expand-all
          :render-content="renderugcontext"
        />
      </el-aside>
      <el-main style="margin-left: 20px;padding: 0 20px 0 10px;flex: 1">
        <el-container>
          <el-card style="width:100%">
            <div slot="header" style="height: 40px; display: flex; justify-content:space-between; align-items: center;">
              <span>类别管理</span>
              <i class="el-icon-close" style="cursor: pointer;" @click="showeditmain=false"></i>
            </div>
            <el-main style="margin-left: 10px;padding:0px;">
              <el-tabs ref="uptabpanel" v-model="upmodel" @tab-click="modechange">
                <el-tab-pane label="新增" name="new">
                  <el-form label-width="80px">
                    <el-form-item label="类别名称">
                      <el-input v-model="new_type_name" placeholder="请输入新的类型名称"></el-input>
                    </el-form-item>
                    <el-form-item label="类别图标">
                      <UpLoadFile ref="upfile" @upok="upok" :ifshowfile="ifshowfile" :ifupload="ifupload" :ifimg="ifimg" :curfilepath="curfilepath" bucketpath="ecomm/goodstype"></UpLoadFile>
                    </el-form-item>
                    <!--
                    <el-form-item label="会员折扣">
                      <el-switch
                        v-model="ifzk"
                        active-text="原价"
                        inactive-text="正常折扣">
                      </el-switch>
                    </el-form-item>
                    -->
                  </el-form>
                </el-tab-pane>
                <el-tab-pane label="编辑" name="update">
                  <el-form label-width="80px">
                    <el-form-item label="当前类名">
                      <el-input v-model="ed_type_name" placeholder="当前的类型名称"></el-input>
                    </el-form-item>
                    <el-form-item label="类别图标">
                      <UpLoadFile ref="upfile" @upok="upok" :ifshowfile="ifshowfile" :ifupload="ifupload" :ifimg="ifimg" :curfilepath="curfilepath" bucketpath="ecomm/goodstype"></UpLoadFile>
                    </el-form-item>
                    <!--
                    <el-form-item label="会员折扣">
                      <el-switch
                        v-model="ed_ifzk"
                        active-text="原价"
                        inactive-text="正常折扣">
                      </el-switch>
                    </el-form-item>
                    -->
                  </el-form>
                </el-tab-pane>
              </el-tabs>
            </el-main>
            <el-footer>
              <el-tooltip style="margin-left: 10px; float: right;" class="item" effect="dark" content="更改当前数据" placement="top-start">
                <el-button type="success" @click="savegtype" icon="el-icon-edit" >更新</el-button></el-tooltip>
            </el-footer>
          </el-card>
        </el-container>
      </el-main>
    </el-container>
    <el-container v-else>
      <el-main>
        <el-tree
          :data="gtypedatas"
          show-checkbox
          ref="gt_tree_list"
          highlight-current
          current-node-key="id"
          node-key="id"
          @current-change = "typchange"
          @node-drag-start="handleDragStart"
          @node-drag-enter="handleDragEnter"
          @node-drag-leave="handleDragLeave"
          @node-drag-over="handleDragOver"
          @node-drag-end="handleDragEnd"
          @node-drop="handleDrop"
          draggable
          :allow-drop="allowDrop"
          :allow-drag="allowDrag"
          :check-strictly = "true"
          :expand-on-click-node="false"
          default-expand-all
          :render-content="renderugcontext"
        />
      </el-main>
    </el-container>
    <el-footer style="display: flex; height: 40px; justify-content: flex-end;">
      <el-button type="primary" icon="el-icon-edit-outline" @click="selecttypes" round>选取分类</el-button>
      <el-button type="primary" icon="el-icon-edit-outline" style="margin-left: 10px;" @click="saveupdate" round>保存更新</el-button>
    </el-footer>
  </el-container>
</template>
<script>
  import Vue from 'vue'
  import axios from 'axios'
  import UpLoadFile from '../upload/UpLoadFile'
  import '../../../static/css/my.css'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'GoodsType',
    components: {
      UpLoadFile
    },
    // 注意 prop 是单向传递，只能从父控件改变数据
    props: {
      ifallfile: {
        type: Boolean,
        required: false
      }
    },
    beforeCreate: function () {
      that = this
      console.log('开始创建')
    },
    data () {
      return {
        ifshowfile:false, // 上传页面参数： 是否显示文件
        curfilepath: '', // 上传页面参数： 当前选中图标文件路径
        ifimg: true, // 上传页面参数： 上传方式是否设定为 图片模式
        ifupload: false, // 上传页面参数： 是否显示上传参数
        gtypedatas: [], // 分类的基础数据
        selecttid: '', // 当前选择的类型ID
        childindex: 0, // 记录子节点 sortindex
        showeditmain: false,
        selnode: '',
        upmodel: 'new',
        showaside: true,
        ifzk: false,
        ed_ifzk: false,
        khid: '', // 客户ID
        ed_type_name: null, // 当前分类名称
        new_type_name: null, // 新类名
        gt_selectnode: []
      }
    },
    mounted: function () {
      that = this
      if (getCookie('cusid') !== 0 || getCookie('cusid') !== '' || getCookie('cusid') !== undefined) {
        this.khid = getCookie('cusid')
      } else {
        this.khid = 1
      }
      if (that.khid === null) {
        that.$message({
          type: 'info',
          message: 'Cookie已失效，请重新登录!'
        })
        that.$router.push({path: '/'})
      } else {
        that.showeditmain = false
        that.get_typedata()
      }
    },
    methods: {
      saveupdate () {
        var update = {
          typetree: JSON.stringify(this.gtypedatas),
          ownphone: localStorage.getItem('username'),
          cusid: localStorage.getItem('cusid')
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/addgtype',
          method: 'post',
          data: update,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.result === 'success') {
              that.showeditmain = false
              that.get_typedata()
              that.$message.success('保存完毕')
            } else {
              that.$message.error('保存失败')
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      renderugcontext (h, { node, data, store }) {
        return (
          <div style="flex: 1; display: flex; align-items: center; justify-content: space-between; font-size: 14px; padding-right: 8px;">
          <div style="display: flex; flex-direction: row; align-items: center; height: 45px; width:100%; border-bottom:1px solid #f3f3f3;justify-content: space-between;">
        <div>
        {
           <span> {data.name} </span>
        }
      </div>
        <div>
        {
        <i style="margin-right: 10px;" class="fa el-icon-plus opicon" on-click={ () => this.add_edit(data)}><span style="margin-left:10px;">新增</span></i>
      }
        {
          <i style="margin-right: 10px;" class="fa fa-pencil-square-o opicon" on-click={ () => this.gt_edit(data)}><span style="margin-left:10px;">编辑</span></i>
        }
        {
          <i class="fa fa-trash-o opicon" on-click={ () => this.remove(node, data)}><span style="margin-left:10px;">删除</span></i>
        }
      </div>
        </div>

        </div>
      )
      },
      // Load 获取类型数据
      get_typedata () {
        var qstr = {
          whereinfo: " ownphone='" + localStorage.getItem('username') + "'",
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/quergtype',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.length > 0) {
              that.gtypedatas = JSON.parse(res.data[0].typetree)
            } else {
              that.gtypedatas = []
              var adata = {
                id: 0,
                name: '默认类别',
                imgurl: '',
                children: []
              }
              that.gtypedatas.push(adata)
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      modechange (tab, event) {
        window.console.log(tab.name)
        if (tab.name === 'new') {
          this.curfilepath = ''
          this.ifshowfile = false
          if (that.$refs.upfile !== undefined) {
            that.$refs.upfile.reset()
          }
        } else {
          this.ifshowfile = true
          that.curfilepath = this.gt_selectnode.imgurl.String
          that.ed_type_name = this.gt_selectnode.name
        }
        that.upmodel = tab.name.toString()
      },
      add_edit (data) {
        window.console.log(that)
        that.showeditmain = true
        that.upmodel = 'new'
        that.showaside = false
        this.gt_selectnode = data
        this.selecttid = data.id
        this.curfilepath = ''
        this.ifshowfile = false
        localStorage.setItem('curfilepath', '')
      },
      gt_edit (data) {
        // 开启编辑模式
        that.showeditmain = true
        that.upmodel = 'update'
        that.ifshowfile = true
        that.showaside = false
        this.ifupload = false
        this.selecttid = data.id
        that.curfilepath = data.imgurl
        that.ed_type_name = data.name
        var ifdistmp = false
        if (data.ifdiscount === 1) {
          ifdistmp = true
        }
        that.ed_ifzk = ifdistmp
        this.gt_selectnode = data
      },
      savegtype () {
        window.console.log(this.gt_selectnode)
        window.console.log(that.upmodel)
        if (that.upmodel === 'new') {
          window.console.log('执行新增')
          window.console.log(this.gt_selectnode)
          var idtmp = parseInt(this.gt_selectnode.id) + parseInt(this.gt_selectnode.children.length) + 1
          var newnode = {
            id: idtmp,
            name: that.new_type_name,
            imgurl: that.curfilepath,
            children: []
          }
          this.gt_selectnode.children.push(newnode)
        } else if (that.upmodel === 'update') {
          this.gt_selectnode.name = that.ed_type_name
          this.gt_selectnode.imgurl = that.curfilepath
          window.console.log(this.gt_selectnode)
        }
      },
      typchange (data,node) {
        window.console.log(data)
        this.$emit('loadgtype',node)
      },
      // 选取当前分类，可多选
      selecttypes () {
        this.$emit('loadgtype', this.$refs.gt_tree_list.getCheckedNodes());
      },
      remove (node, data) {
        const parent = node.parent;
        const children = parent.data.children || parent.data;
        const index = children.findIndex(d => d.id === data.id);
        children.splice(index, 1);
      },
      closemain () {
        this.showeditmain = false
      },
      upok (curpath, fileList) {
        that.curfilepath = curpath
        window.console.log(fileList)
      },
      handleDragStart (node, ev) {
        console.log('drag start', node);
      },
      handleDragEnter (draggingNode, dropNode, ev) {
        console.log('tree drag enter: ', dropNode.name);
      },
      handleDragLeave (draggingNode, dropNode, ev) {
        console.log('tree drag leave: ', dropNode.name);
      },
      handleDragOver (draggingNode, dropNode, ev) {
        console.log('tree drag over: ', dropNode.name);
      },
      handleDragEnd (draggingNode, dropNode, dropType, ev) {
        console.log('tree drag end: ', dropNode && dropNode.name, dropType);
      },
      handleDrop (draggingNode, dropNode, dropType, ev) {
        console.log('tree drop: ', dropNode.name, dropType);
      },
      allowDrop (draggingNode, dropNode, type) {
        if (dropNode.data.name === '二级 3-1') {
          return type !== 'inner';
        } else {
          return true;
        }
      },
      allowDrag (draggingNode) {
        return draggingNode.data.name.indexOf('三级 3-2-2') === -1;
      }
    }
  }
  function getCookie (name) {
    var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
    return v ? v[2] : null
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/newgoods/GTypeList.vue